import {
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
} from '../../details';
import assetCategories from 'static/asset_categories.json';

export const transform = (list = [], globalDepartmentList = []) => {
  // get all the valid departments available through  the asset type list
  const selectedDepartments = globalDepartmentList.filter(({ id }) => {
    return list.some(({ departmentIds }) => departmentIds?.includes(id));
  });

  const addIconToAssetTypeList = list
    .map(assetType => {
      const categoryImage = assetCategories.find(f => {
        return f.id === assetType.category;
      });
      return (
        categoryImage && {
          ...assetType,
          categoryIcon: categoryImage?.icon,
        }
      );
    })
    .filter(f => f);

  return addIconToAssetTypeList.map(data => ({
    id: data?.id,
    assetTypeId: getItemOrDefaultToValue(data, 'assetTypeId', '-'),
    category: {
      id: getItemOrDefaultToValue(data, 'category', '-'),
      icon: getItemOrDefaultToValue(data, 'categoryIcon', '-'),
      name: getItemOrDefaultToValue(data, 'category', '-'),
    },
    name: getItemOrDefaultToValue(data, 'name', '-'),
    handoverRequired: getItemOrDefaultToValue(data, 'handoverRequired', '-'),
    qualificationRequired: getItemOrDefaultToValue(
      data,
      'qualificationRequired',
      '-',
    ),
    archived: getItemOrDefaultToValue(data, 'archived', '-'),
    description: getItemOrDefaultToValue(data, 'description', '-'),
    // this key is for displaying departments in list view
    departments: getDepartmentNamesArray(globalDepartmentList, data),
    // this key is for displaying departments in detail panel
    departmentForDetails: selectedDepartments.filter(f =>
      data?.departmentIds?.includes(f.id),
    ),
    departmentIds: selectedDepartments
      .filter(f => data?.departmentIds?.includes(f.id))
      ?.map(m => m?.id),
  }));
};
